import { useEffect, useState } from 'react';
import { getArticles, deleteArticle, ArticleSummary } from '../services/adminApi';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ArticlesPage = () => {
  const { t } = useTranslation();
  const [articles, setArticles] = useState<ArticleSummary[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    try {
      const items = await getArticles();
      setArticles(items);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : t('articles.loadFailed', 'Failed to load articles.'));
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleDelete = async (id: string) => {
    if (!confirm(t('articles.deleteConfirm', 'Delete this article?'))) return;
    try {
      await deleteArticle(id);
      await load();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : t('articles.deleteFailed', 'Delete failed'));
    }
  };

  return (
    <div className="page-grid">
      <div className="section-heading">
        <h2>{t('articles.title', 'Articles')}</h2>
        <p>{t('articles.subtitle', 'Manage news, case studies and announcements.')}</p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="admin-panel">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <h3 style={{ margin: 0 }}>{t('articles.allTitle', 'All articles')}</h3>
          <Link to="/admin/articles/new" className="btn btn-primary">{t('articles.new', 'New article')}</Link>
        </div>

        <div style={{ display: 'grid', gap: '1rem', marginTop: '1rem' }}>
          {articles.map((a) => (
            <div key={a.id} className="admin-panel" style={{ padding: '1rem' }}>
              <h4 style={{ margin: 0 }}>{a.title}</h4>
              <p className="muted" style={{ margin: '0.5rem 0 0' }}>
                {a.category} • {new Date(a.publishedAt).toLocaleDateString()}
              </p>
              <div className="admin-actions">
                <Link to={`/admin/articles/${a.id}`} className="btn btn-secondary">{t('common.edit', 'Edit')}</Link>
                <button type="button" className="btn btn-ghost" onClick={() => handleDelete(a.id)}>
                  {t('common.delete', 'Delete')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArticlesPage;
